import * as React from 'react'
import {FormControl, InputLabel, Select, MenuItem, Theme, createStyles, withStyles, Input, WithStyles, Chip} from '@material-ui/core'
import {WithI18n, withI18n} from 'src/core/i18n/withI18n'
import {RootState} from 'src/core/redux/reducer/index'
import {compose} from 'redux'
import {connect} from 'react-redux'
import { ICategory } from 'src/type/category'
import autobind from 'autobind-decorator'
import { fetchCategories } from 'src/core/redux/action/categoriesAction'
import { slugify, replaceDetteWithTaux, replaceTauxWithDette } from 'src/shared/utils/helpers'
import { replaceNameCategory } from 'src/shared/CategoriesFilter/helpers'

const styles = (t: Theme) => createStyles({
    formControl: {
        margin: t.spacing.unit,
        width: '100%'
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: t.spacing.unit / 4,
    },
    noLabel: {
        marginTop: t.spacing.unit * 3,
    },
    parents: {
        fontWeight: 'bold',
        color: t.palette.primary.main,
        opacity: 1
    },
    child: {
        paddingLeft: '24px'
    }
});

interface IProps extends WithI18n,
  WithStyles<typeof styles>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props>  {
  dispatch: any;
  input: any;
  onChange: (categoriesSelected: any) => void;
  label?: string;
  reset?: any;
  isEcoWatch?: boolean;
}

interface IStates {
  categoriesSelected: any;
  categoriesDispo: any;
  categoriesCompare: any;
}


class NewsCategoriesFilter extends React.Component<IProps & ReturnType<typeof dispatch2props>, IStates> {
  state = {
    categoriesSelected: [],
    categoriesCompare: null,
    categoriesDispo: ["principale", "actu"]
  };

  componentDidMount(){
    this.props.fetch().then(res => {
        res.map(c => c.sub_categories.sort((a, b) => a.localeCompare(b)))
        this.buildCategoriesCompare(res)
    })

    // this function is called from parent for reset this filter
    if(this.props.reset) this.props.reset(this.resetFilter)
  }

  render() {
    const {t, categories, classes, label} = this.props
    return (
      <>
          {categories &&
             <FormControl className={classes.formControl}>
                <InputLabel htmlFor="select-multiple-chip">
                    {label ? label :t.news_filter_par_categories}
                </InputLabel>
                <Select
                    multiple
                    value={this.state.categoriesSelected}
                    onChange={this.handleChange}
                    input={<Input id="select-multiple-chip" />}
                    renderValue={this.renderValue}
                    fullWidth={true}
                >
                    {this.buildItemCategories(categories).map(c => 
                        <MenuItem 
                            key={c.slug} 
                            value={c.name} 
                            disabled={c.lv === 1 ? true : false} 
                            className={c.lv === 1 ? classes.parents : classes.child}
                        >
                            <span>{c.name}</span>
                        </MenuItem>
                    )}
                </Select>
            </FormControl>
          }

      </>
    )
  }

   @autobind
   private resetFilter(){
    this.setState({categoriesSelected: []})
    // this.props.fetch().then(res => this.buildCategoriesCompare(res))
  }

  private buildCategoriesCompare(categories: any){
    const {categoriesDispo} = this.state
    this.setState({categoriesCompare : categories.filter(c => (categoriesDispo.includes(c.slug)))})
  }

  private buildItemCategories(categories: ICategory[]){
    const {categoriesDispo} = this.state
    const build:any[] = [];
    categories.sort((a, b) => categoriesDispo.indexOf(a.slug) - categoriesDispo.indexOf(b.slug))  // sort by ordre of categoriesDispo
               .map(category => {
        if(categoriesDispo.includes(category.slug)){
            this.buildItemCategory(category, build)
        }
    })
    return build;
  }

  private buildItemCategory(category: ICategory, build:any[]){
    build.push({
        lv: 1,
        name: replaceNameCategory(category.name),
        slug: category.slug,
        color: category.background_color
    })
    if(category.sub_categories.length > 0){
      if(this.props.isEcoWatch){
        category.sub_categories.filter(x => slugify(x) !== "economique").map(subCategory => {
            build.push({
                lv: 2,
                name: this.switchLabelSubCategory(subCategory),
                slug: slugify(subCategory),
                group: category.slug,
                color: category.background_color
            })
        })
      } else {
        category.sub_categories.map(subCategory => {
            build.push({
                lv: 2,
                name: this.switchLabelSubCategory(subCategory),
                slug: slugify(subCategory),
                group: category.slug,
                color: category.background_color
            })
        })
      }
    }
  }

  private switchLabelSubCategory(c: string){
    const labelToSwitch = {
      Focus: "Focus Actu",
      Hebdo: "Hebdo Eco",
      Perspectives: "Perspectives Eco",
      "PME dette": "Flash Taux",
      "PME placement": "Flash Placement",
      "PME change": "Flash Change",
      Points: "Tendances Marché",
      Dette: "Taux",
      dette: "taux"
    }
    return labelToSwitch[c] ? labelToSwitch[c] : c
  }

  private buildObjectFilter(selected: any){
    const {categoriesCompare} = this.state
    /* TODO
        optimize
    */
    const mapFilter = new Map();
    mapFilter.set('actu-nuage', [])
    mapFilter.set('actu', [])
    mapFilter.set('produit', [])
    mapFilter.set('principale', [])
    selected.map(s => {
        categoriesCompare.map(cc => {
            if(cc.sub_categories.includes(replaceTauxWithDette(s))){               // cuz we convert Dette to Taux on the dropdown select, 
                mapFilter.get(cc.slug).push(slugify(replaceTauxWithDette(s)))      // so we neeed to re-convert in handleFilter to get the true value
            }
        })
    })
    return mapFilter;
  }

  @autobind
  private handleChange(event: any) {
    this.setState({ categoriesSelected: event.target.value });
    this.buildObjectFilter(event.target.value)
    this.props.onChange(this.buildObjectFilter(event.target.value));
  }

  @autobind
  private renderValue(selected: any){
    const {classes} = this.props
      return (
        <div className={classes.chips}>
            {selected.map(value => (
                <Chip key={value} label={replaceDetteWithTaux(value)} className={classes.chip} />
            ))}
        </div> 
      )
  }

}

const state2props = (state: RootState) => ({
  categories: state.categories.entities,
})

const dispatch2props = (dispatch: any) => ({
    fetch: () => dispatch(fetchCategories()),
})

export default compose(
  withI18n,
  withStyles(styles),
  connect(state2props, dispatch2props),
)(NewsCategoriesFilter)



// WEBPACK FOOTER //
// ./src/shared/CategoriesFilter/NewsCategoriesFilter.tsx